import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleKeyword, upsertKeywordMetrics } from "src/app/types/keywords";
import { SimpleFormCheck } from "../form/SimpleFormCheck";
import SimpleModal from "../SimpleModal/SimpleModal";
import { KeywordsTransport } from "src/app/transports/keywords";

export interface IKeywordMetricsModalContainer {
    handleClose?: () => {};
    entities: SimpleKeyword[];
    updateGridOnSave?: (object: any, isNew: boolean) => void;
}

const KeywordMetricsModalContainer = (props: IKeywordMetricsModalContainer) => {
    const { handleClose = () => {}, entities } = props;

    const [loadingApi, setLoadingApi] = useState(false);

    const { formatMessage } = useIntl();
    const handleSubmit = async (_values: { metrics: string[] }) => {
        setLoadingApi(false);
        const ids = entities.map((entity) => entity.id);

        try {
            await KeywordsTransport.updateMetrics(ids, _values.metrics);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoadingApi(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.keywordMetrics" })}
            handleClose={handleClose}
            loading={loadingApi}
            formId="keywordMetrics"
            showModal={true}
            buttonConfirmationLabel={formatMessage({ id: "common.action.verified" })}
            modalProps={{ size: "sm" }}
        >
            <>
                <Formik
                    initialValues={{ metrics: KeywordsTransport.getMetrics() }}
                    validationSchema={upsertKeywordMetrics}
                    onSubmit={handleSubmit}
                >
                    <Form id="keywordMetrics">
                        {KeywordsTransport.getMetrics().map((metric, index) => (
                            <SimpleFormCheck
                                key={index}
                                name="metrics"
                                label={formatMessage({ id: `common.field.${metric}` })}
                                value={metric}
                            />
                        ))}
                    </Form>
                </Formik>
            </>
        </SimpleModal>
    );
};

export default KeywordMetricsModalContainer;
